var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('addOrder',{on:{"sendOrderItems":function($event){return _vm.calculateAmount($event)}}}),_c('EmptySpace'),_c('PaymentComponent',{attrs:{"allAmount":_vm.allAmount,"orderDetails":_vm.orderDetails}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }